'use client';
import { useSearchParams } from 'next/dist/client/components/navigation';
import Link from 'next/link';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Helper from '../../../modules/Helper';

const Footer: FC = () => {
	const { t } = useTranslation();
	const searchParams = useSearchParams();
	const lang = searchParams?.get('lng') as string;

	return (
		<footer lang={lang}>
			<div className="container ">
				<div className="row " style={{ minHeight: '220px' }}>
					<div className="col-12 text-center pt-5 pb-5">
						<ul id="footer-links">
							<li>
								<Link target="_blank" href={Helper.getLink('/contact-us')}>
									{t('keywords.contactUs')}
								</Link>
							</li>
							<li>
								<Link target="_blank" href={Helper.getLink('/terms')}>
									{t('keywords.termsOfUser')}
								</Link>
							</li>
							<li>
								<Link target="_blank" href={Helper.getLink('/privacy')}>
									{t('keywords.privacyPolicy')}
								</Link>
							</li>
						</ul>
					</div>
					<br />
					<div className="col-12 pt-1 pb-1 about-us-text">
						<p>{t('main.footerAboutUs')}</p>
					</div>
					<div className="col-12 text-center pt-4 pb-3">
						<p>{t('main.footerCopyrightText', { currentYear: new Date().getFullYear() })}</p>
					</div>
				</div>
			</div>
		</footer>
	);
};
export default React.memo(Footer);
